export default function ArrowObs() {
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target.classList.contains('footer-arrow') && entry.isIntersecting) {
        entry.target.classList.add('animate-up');
      }
    });
  });

  const footerArrow = document.querySelectorAll('.footer-arrow');
  footerArrow.forEach(arrow => observer.observe(arrow));

  const headerObs = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.target.classList.contains('homepage-arrow-down') && entry.isIntersecting) {
        entry.target.classList.add('animate-down');
      }
    });
  });

  const headerArrow = document.querySelectorAll('.homepage-arrow-down');
  headerArrow.forEach(arrow => headerObs.observe(arrow));
}
